import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-clock",
  "use": "icon-clock-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-clock\"><path fill-rule=\"evenodd\" d=\"m16 2 .311.003C23.87 2.171 30 8.404 30 16c0 7.7-6.3 14-14 14S2 23.7 2 16 8.3 2 16 2m0 2.333C9.467 4.333 4.333 9.467 4.333 16c0 6.433 4.977 11.508 11.366 11.663l.301.004c6.533 0 11.667-5.134 11.667-11.667S22.533 4.333 16 4.333m1.167 3.5V16.7l4.433 4.2-1.867 1.867-4.9-5.134v-9.8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol